__turbopack_context__.v({
  "button": "NumericStepper-module__CfmyJG__button",
  "input": "NumericStepper-module__CfmyJG__input",
  "wrapper": "NumericStepper-module__CfmyJG__wrapper",
  "wrapperError": "NumericStepper-module__CfmyJG__wrapperError",
});
